import { Component, inject, Input, PLATFORM_ID } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AuthService, GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { DocumentSpecificSearchService } from '../../kb-CustomDocumentSearchTab/document-specific-search.service';
import { FileDownloadService } from '@spartacus/storefront';
import { isPlatformBrowser } from '@angular/common';
import { DocumnetWebtrekkTrackingService } from '../kb-document-grid/documnetWebtrekkTrackingService';
import { saveAs } from 'file-saver';
import { Subject, take, takeUntil } from 'rxjs';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
@Component({
  selector: 'app-kb-document-list',
  templateUrl: './kb-document-list.component.html',
  styleUrls: ['./kb-document-list.component.scss'],
  standalone: false
})
export class KbDocumentListComponent {
  @Input() product: any;
  @Input() searchQuery: any;
  isMobile: boolean;
  addfav: boolean;
  isLoggedIn: boolean = false;
  tooltip: boolean = false;
  platformId = inject(PLATFORM_ID);
  private destroy$ = new Subject<void>();
  private webtrekkTrackingService = inject(DocumnetWebtrekkTrackingService)
  constructor(public breakpointObserver: BreakpointObserver,
    private AuthService: AuthService,
    private service: DocumentSpecificSearchService,
    private globalmsgService: GlobalMessageService,
    private fileDownloadService: FileDownloadService,
    private activeCartService: ActiveCartFacade
  ) {
  }
  ngOnChanges() {
    if (this.product?.isFavorite) {
      this.addfav = true;
    }
  }
  ngOnInit() {
    this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        this.isMobile = result.matches;
      });
    this.AuthService.isUserLoggedIn().pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data) {
        this.isLoggedIn = data;
      }
      else {
        this.isLoggedIn = false;
      }
    })
  }
  SubscribeDoc(data: any) {
    if (this.addfav) {
      this.unSubscribeDoc(data);
    } else {
      if (this.service.inPdp) {
        this.service.getDownloadPopup().pipe(takeUntil(this.destroy$)).subscribe((response: any) => {
          const payLoad = {
            code: data.code,
            email: response.displayUid,
            name: response.name,
            revision: data.revision,
            language: data.isoCode
          }
          this.service.addToFavFromPdp(payLoad).pipe(takeUntil(this.destroy$)).subscribe();
        });
      } else {
        this.service.getDownloadPopup().pipe(takeUntil(this.destroy$)).subscribe((response: any) => {
          const payLoad = {
            code: data.code,
            email: response.displayUid,
            name: response.name,
            revision: data.revision,
            language: data.isoCode
          }
          this.service.exceptPdpAddToFavFrom(payLoad).pipe(takeUntil(this.destroy$)).subscribe();
        });
      }
    }


  }
  unSubscribeDoc(data: any) {
    if (this.service.inPdp) {
      this.service.removeFavFromPdp(data).pipe(takeUntil(this.destroy$)).subscribe();
    } else {
      this.service.removeFavDoc(data).pipe(takeUntil(this.destroy$)).subscribe();
    }

  }

  callApi(data: any) {
    this.trackDownload(data.url);
    if (data.url.includes('.pdf')) {
      const payLoadforpdf = {
        url: data.url,
        documentCode: data.code,
        documentLanguage: data.language,
        revision: data.revision,
      }
      this.service.getTimeStampInPdf(payLoadforpdf).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res: any) => {
          const file = new Blob([res], { type: res.type });
          const url = URL.createObjectURL(file);
          if (isPlatformBrowser(this.platformId)) {
            if (isPlatformBrowser(this.platformId)) {
              const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
              if (isIOS) {
                saveAs(file, `${data.code}.pdf`);
              }
              else {
                const link = document.createElement('a');
                link.href = url;
                link.target = "_blank";
                link.click();
              }
            }
          }
        },
        error: () => {

        },
      });

    }
    else {
      if (isPlatformBrowser(this.platformId)) {
        const link = document.createElement('a');
        link.href = data.url;
        link.target = "_blank";
        link.click();
      }
    }
  }
  trackDownload(name: string): void {
    /*  this.mapp.action({
       name: 'NA_Document_Download_' + name,
     });
     this.mapp.trackAction(true); */
    this.activeCartService.getActive().pipe(
      take(1)
    ).subscribe((item: any) => {
      this.webtrekkTrackingService.trackAction(name, item?.currentB2BUnit?.uid);
    });
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
